import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';

const DocumentReportAppliedFilters = ({ appliedFilters = [], onRemove, onClearAll }) => {
  const { documentReports } = useTranslatedMessages();
  const labels = documentReports?.filters ?? {};

  if (!appliedFilters.length) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      spacing={0.75}
      sx={{ borderTop: '1px solid', borderColor: 'divider', pt: 1.5, mt: 1.5 }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>
        {labels.applied_filters ?? 'Applied filters'}
      </Typography>

      {appliedFilters.map((filter) => (
        <Chip
          key={`${filter.key}-${filter.value}`}
          size="small"
          onDelete={() => onRemove(filter.key, filter.value)}
          deleteIcon={<CloseIcon />}
          label={
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
              <Box component="span" sx={{ color: 'text.secondary' }}>
                {filter.categoryLabel}:
              </Box>
              <Box
                component="span"
                sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                title={filter.label}
              >
                {filter.label}
              </Box>
            </Box>
          }
          sx={{
            bgcolor: 'action.hover',
            borderRadius: 1,
            height: 24,
            fontSize: 12,
            fontWeight: 400,
            '& .MuiChip-label': { pl: 1, pr: 0.5 },
            '& .MuiChip-deleteIcon': { fontSize: 14, mr: 0.5, ml: 0 },
          }}
        />
      ))}

      <Button
        size="small"
        color="inherit"
        onClick={onClearAll}
        sx={{ height: 24, minWidth: 0, px: 1, fontSize: 12, color: 'text.secondary', textTransform: 'none' }}
      >
        {labels.clear_all ?? 'Clear all'}
      </Button>
    </Stack>
  );
};

export default DocumentReportAppliedFilters;
